import React, { useContext } from "react";
import styled from "styled-components";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
// Import react-toastify
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// Images
import Newpassport from "../assets/passportimg/Newpassport.png";
import Reisshupassport from "../assets/passportimg/Reisshupassport.png";
import Search from "../assets/passportimg/Search.png";
import file from "../assets/passportimg/file.png";
import creditcard from "../assets/passportimg/creditcard.png";
import NameEdit from "../assets/passportimg/NameEdit.png";
import Visa from "../assets/passportimg/Visa.png";

const Services = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  const services = [
    {
      img: Newpassport,
      title: "Apply For Fresh Passport Assistance",
      route: "/ApplyFreshPassport",
      text: "Submit a new passport application for fresh issuance of your travel document.",
      status: "available",
    },
    {
      img: Reisshupassport,
      title: "Apply Reissue Passport Assistance",
      route: "/ApplyReissuePassport",
      text: "Renew or reissue your passport due to expiration, damage, or page exhaustion.",
      status: "available",
    },
    {
      img: file,
      title: "Download Appointment Receipt ",
      route: "/Appointment_Receipt",
      text: "Download and print your passport appointment confirmation receipt.",
      status: "not-available",
    },
    {
      img: Search,
      title: "Required Document For Passport ",
      route: "/EnquiryAndDocument",
      text: "Get help with document verification, requirements, and general inquiries.",
      status: "available",
    },
    {
      img: NameEdit,
      title: "Change in Name Assistance",
      route: "/NameChanging",
      text: "Update or correct your name details in your passport records.",
      status: "working",
    },
    {
      img: Search,
      title: "Required Document For Visa ",
      route: "/",
      text: "Working Process...!",
      status: "not-available",
    },
    {
      img: Visa,
      title: "Apply For Visa ",
      route: "/",
      text: "Working Process...!",
      status: "not-available",
    },
    {
      img: creditcard,
      title: "Online Payment",
      route: "/Payments",
      text: "Make secure online payments for passport services and applications.",
      status: "working",
    },
  ];

  const handleProtectedClick = (route) => {
    if (!user) {
      // Use toast instead of alert
      toast.error("Please log in to access this service.", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      navigate("/Login");
      return;
    }
    navigate(route);
  };

  return (
    <>
      <Wrapper>
        <Header>
          Know About Our Services
          <SubText>
            We provide comprehensive passport services including new
            applications, reissues, updates, and online payments. Your trusted
            partner for a smooth and efficient passport process.
          </SubText>
        </Header>

        <Grid>
          {services.map((service, index) => (
            <Card key={index}>
              <Tag status={service.status}>
                {service.status === "available"
                  ? "#Available"
                  : service.status === "not-available"
                  ? "#Not Available Now"
                  : "#Working Process"}
              </Tag>
              <Icon src={service.img} alt={service.title} />
              <Title>{service.title}</Title>
              <Description>{service.text}</Description>

              {user && service.status !== "not-available" ? (
                <StyledLink to={service.route}>{service.title} →</StyledLink>
              ) : (
                <DisabledButton
                  onClick={() =>
                    service.status !== "not-available" &&
                    handleProtectedClick(service.route)
                  }
                >
                  {user ? "Coming Soon" : "Login to Access"} →
                </DisabledButton>
              )}
            </Card>
          ))}
        </Grid>
      </Wrapper>
      {/* Toast container for displaying toasts */}
      <ToastContainer />
    </>
  );
};

export default Services;

// Styled Components

const Wrapper = styled.section`
  /* background: #0e0e10; */
  /* padding: 60px 10px; */
  /* background: linear-gradient(145deg, #0d0d0d, #1a1a1a); */

  color: white;
  text-align: center;
  margin-top: 50px;
  margin-bottom: 50px;
`;

const Header = styled.h2`
  font-size: 2.5rem;
  font-weight: 600;
  margin-bottom: 10px;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;

  .rotating-text-wrapper {
    margin: 10px 0;
  }

  p,
  div,
  ${"" /* This targets SubText if styled as a `p` or `div` */} {
    margin: 5px 0;
  }

  @media (max-width: 768px) {
    font-size: 1.8rem;
  }
`;

const SubText = styled.p`
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif !important;
  color: #aaa;
  font-size: 1rem;
  max-width: 850px;
  margin: 0 auto 40px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
  justify-items: center;
  margin-top: 20px;
  border-radius: 12px;
`;

const Card = styled.div`
  /* background: linear-gradient(90deg, #0e0e10 0%, rgba(23, 23, 26, 0.55) 100%); */
  background: linear-gradient(145deg, #0d0d0d, #1a1a1a);
  padding: 30px 20px;
  /* border-radius: 12px; */
  text-align: start;
  position: relative;
  border: 1px solid #353535;
  width: 100%;
  max-width: 300px;
  min-height: 280px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: 0.3s ease;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  cursor: pointer;
  &:hover {
    transform: translateY(-6px);
    /* border: 1px solid #e6e6e6; */
    border: 1px solid #646464;
    border-radius: 12px;
  }
`;

const Icon = styled.img`
  width: 74px;
  height: 74px;
  margin-bottom: 20px;
`;

const Title = styled.h3`
  font-size: 1.1rem;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 0px;
`;

const Description = styled.p`
  font-size: 0.75rem;
  color: #888;
  margin-bottom: 5px;
`;

const Button = styled(Link)`
  background: none;
  border: none;
  color: #ffffff;
  font-size: 0.7rem;
  padding: 8px 12px;
  cursor: pointer;
  border: 1px solid #444;
  border-radius: 8px;
  transition: 0.2s ease;
  text-decoration: none;
  &:hover {
    background: #194bfd;
    background: linear-gradient(
      90deg,
      rgba(25, 75, 253, 1) 0%,
      rgba(173, 19, 251, 1) 100%
    );
    color: #e9e9e9;
    /* border: 2px solid #9d4edd; */
    border: none;
  }
`;

const Tag = styled.span`
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 0.65rem;
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 6px;
  transition: 0.3s ease;

  background-color: ${({ status }) =>
    status === "available"
      ? "#28a745"
      : status === "not-available"
      ? "#dc3545"
      : "#ffc107"};
  color: #ffffff;
  /* text-transform: uppercase; */
  letter-spacing: 0.5px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
`;

const StyledLink = styled(Link)`
  background: none;
  border: none;
  color: #ffffff;
  font-size: 0.7rem;
  padding: 8px 12px;
  cursor: pointer;
  border: 1px solid #444;
  border-radius: 8px;
  transition: 0.2s ease;
  text-decoration: none;
  text-align: center;

  &:hover {
    background: #194bfd;
    background: linear-gradient(
      90deg,
      rgba(25, 75, 253, 1) 0%,
      rgba(173, 19, 251, 1) 100%
    );
    color: #e9e9e9;
    border: none;
  }
`;

const DisabledButton = styled.button`
  background: none;
  border: 1px solid #444;
  color: #aaa;
  font-size: 0.7rem;
  padding: 8px 12px;
  border-radius: 8px;
  width: 100%;
  cursor: pointer;
  text-align: center;

  &:hover {
    background-color: #222;
    color: #ccc;
  }
`;
